import React, { Suspense, lazy } from "react";

import { LoadingSpinner } from "src/components";
import { DIALOG_NAME } from "src/constants";
import useGlobalDialog from "src/redux/hooks/useGlobalDialog";

const WalletSettingsDialog = lazy(() => import(
  /* webpackChunkName: "core-components-deferred" */
  "src/components/Dialogs/WalletSettingsDialog"
));
const KYCFlowDialog = lazy(() => import(
  /* webpackChunkName: "core-components-deferred" */
  "src/components/Dialogs/KYCFlowDialog"
));
const KYCResetDialog = lazy(() => import(
  /* webpackChunkName: "core-components-deferred" */
  "src/components/Dialogs/KYCResetDialog"
));
const KYCStatusDialog = lazy(() => import(
  /* webpackChunkName: "core-components-deferred" */
  "src/components/Dialogs/KYCStatusDialog"
));
const KYCFinishedDialog = lazy(() => import(
  /* webpackChunkName: "core-components-deferred" */
  "src/components/Dialogs/KYCFinishedDialog"
));
const KYBReviewDialog = lazy(() => import(
  /* webpackChunkName: "core-components-deferred" */
  "src/components/Dialogs/KYBReviewDialog"
));
const CountryResetDialog = lazy(() => import(
  /* webpackChunkName: "core-components-deferred" */
  "src/components/Dialogs/CountryResetDialog"
));
const AccountBlockedDialog = lazy(() => import(
  /* webpackChunkName: "core-components-deferred" */
  "src/components/Dialogs/AccountBlockedDialog"
));
const AccountUnblockedDialog = lazy(() => import(
  /* webpackChunkName: "core-components-deferred" */
  "src/components/Dialogs/AccountUnblockedDialog"
));
const AccessUnavailableDialog = lazy(() => import(
  /* webpackChunkName: "core-components-deferred" */
  "src/components/Dialogs/AccessUnavailableDialog"
));
const VpnBlockedDialog = lazy(() => import(
  /* webpackChunkName: "core-components-deferred" */
  "src/components/Dialogs/VpnBlockedDialog"
));
const SeriesPausedDialog = lazy(() => import(
  /* webpackChunkName: "core-components-deferred" */
  "src/components/Dialogs/SeriesPausedDialog"
));
const MaxAmountReachedDialog = lazy(() => import(
  /* webpackChunkName: "core-components-deferred" */
  "src/components/Dialogs/Investment/MaxAmountReachedDialog"
));
const UnlinkWalletDialog = lazy(() => import(
  /* webpackChunkName: "core-components-deferred" */
  "src/components/Dialogs/UnlinkWalletDialog"
));
const GrantAcceptSuccessDialog = lazy(() => import(
  /* webpackChunkName: "core-components-deferred" */
  "src/components/Dialogs/GrantAcceptSuccessDialog"
));
const TransferTokenDialog = lazy(() => import(
  /* webpackChunkName: "core-components-deferred" */
  "src/components/Dialogs/TransferTokenDialog"
));

const DialogWrapper = () => {
  const { data: currentDialog, setData: setCurrentDialog } = useGlobalDialog();
  // No open dialog
  if (!currentDialog?.name) return null;

  return (
    <Suspense fallback={<LoadingSpinner />}>
      {currentDialog.name === DIALOG_NAME.WALLET_SETTINGS && (
        <WalletSettingsDialog onClose={() => setCurrentDialog(null)} />
      )}
      {currentDialog.name === DIALOG_NAME.KYC_RESET && (
        <KYCResetDialog onClose={() => setCurrentDialog(null)} />
      )}
      {currentDialog.name === DIALOG_NAME.KYC_FLOW && (
        <KYCFlowDialog onClose={() => setCurrentDialog(null)} />
      )}
      {currentDialog.name === DIALOG_NAME.KYC_FINISHED && (
        <KYCFinishedDialog onClose={() => setCurrentDialog(null)} />
      )}
      {currentDialog.name === DIALOG_NAME.KYC_STATUS && (
        <KYCStatusDialog onClose={() => setCurrentDialog(null)} />
      )}
      {currentDialog.name === DIALOG_NAME.KYB_REVIEW && (
        <KYBReviewDialog onClose={() => setCurrentDialog(null)} />
      )}
      {currentDialog.name === DIALOG_NAME.COUNTRY_RESET && (
        <CountryResetDialog onClose={() => setCurrentDialog(null)} />
      )}
      {currentDialog.name === DIALOG_NAME.ACCOUNT_BLOCKED && (
        <AccountBlockedDialog onClose={() => setCurrentDialog(null)} />
      )}
      {currentDialog.name === DIALOG_NAME.ACCOUNT_UNBLOCKED && (
        <AccountUnblockedDialog onClose={() => setCurrentDialog(null)} />
      )}
      {currentDialog.name === DIALOG_NAME.ACCESS_UNAVAILABLE && (
        <AccessUnavailableDialog onClose={() => setCurrentDialog(null)} />
      )}
      {currentDialog.name === DIALOG_NAME.VPN_BLOCKED && (
        <VpnBlockedDialog onClose={() => setCurrentDialog(null)} />
      )}
      {currentDialog.name === DIALOG_NAME.SERIES_PAUSED && (
        <SeriesPausedDialog onClose={() => setCurrentDialog(null)} />
      )}
      {currentDialog.name === DIALOG_NAME.MAX_AMOUNT_REACHED && (
        <MaxAmountReachedDialog onClose={() => setCurrentDialog(null)} />
      )}
      {currentDialog.name === DIALOG_NAME.UNLINK_WALLET && (
        <UnlinkWalletDialog {...currentDialog.props} onClose={() => setCurrentDialog(null)} />
      )}
      {currentDialog.name === DIALOG_NAME.GRANT_ACCEPT_SUCCESS && (
        <GrantAcceptSuccessDialog
          {...currentDialog.props}
          onClose={() => setCurrentDialog(null)}
        />
      )}
      {currentDialog.name === DIALOG_NAME.TRANSFER_TOKENS && (
        <TransferTokenDialog
          {...currentDialog.props}
          onClose={() => setCurrentDialog(null)}
        />
      )}
    </Suspense>
  );
};

export default DialogWrapper;
